<template>
  <span>
    <b-sidebar
      sidebar-class="big_sidebar"
      id="add-meeting"
      v-model="show"
      :title="$t('MESSAGES.TYPE.jitsi-secure-meeting')"
      right
      backdrop
      no-slide
      lazy
      shadow
      no-header-close
      no-close-on-backdrop
      no-close-on-esc
      @shown="shown"
      @hidden="closeBtn"
    >
      <div class="pt-4 pb-4">
        <b-overlay :show="loading" rounded="sm">
          <div class="px-3 py-2 view-content create-message" v-if="settings">
            <div v-show="step == 1">
              <div class="info-header mt-2">{{ $t("ADD_RECIPIENTS") }}</div>

              <SearchRecipients
                class="w-100 mt-2"
                user_uuid=""
                functionbox_uuid=""
                v-model="addresses"
                :key="'forceRedrawRecipientsKey_' + forceRedrawRecipientsIndex"
                @forceRedraw="forceRedrawRecipientsIndex++"
              ></SearchRecipients>

              <b-form-input trim
                class="mt-2 pl-2"
                input-id="subject"
                id="subject"
                :disabled="settings.subject != ''"
                :placeholder="$t('SUBJECT')"
                :state="subject.length <= 256"
                autocomplete="off"
                v-model="subject"
              ></b-form-input>
              <div class="clearfix">
                <div class="float-left">
                  <div class="error-text" v-if="subject.length > 256">
                    {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
                  </div>
                  <b-form-text id="subject" v-if="settings.subject == ''">
                    {{ $t("SUBJECT_EMAIL") }}
                  </b-form-text>
                  <b-button
                    v-if="settings.subject != '' && settings.unlock_subject"
                    @click="unlockSubject"
                    size="sm"
                    class="no-border mt-2 mb-2"
                    ><i class="fal fa-unlock"></i>
                    {{ $t("BTN_UNLOCK_SUBJECT") }}</b-button
                  >
                </div>
                <div class="float-right">
                  <div class="text-right">
                    <small class="pull-right">{{ subject.length }}/256</small>
                  </div>
                </div>
              </div>

              <div>
                <h6 class="mt-2">{{ $t("MESSAGES.EXTERNAL_TEXT") }}</h6>
                <div class="mt-2 mb-2">
                  <b-form-textarea
                    class="textarea"
                    id="externalText"
                    ref="externalText"
                    :state="external_text.length <= 1500"
                    v-model="external_text"
                    :disabled="settings.email_body != ''"
                    :placeholder="$t('CONTENT')"
                    rows="3"
                    max-rows="3"
                  ></b-form-textarea>
                  <div class="clearfix">
                    <div class="float-left">
                      <div
                        class="error-text"
                        v-if="external_text.length > 1500"
                      >
                        {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
                      </div>
                      <b-form-text
                        id="email_body"
                        v-if="settings.email_body == ''"
                      >
                        {{ $t("MESSAGES.EXTERNAL_TEXT_INFORMATION") }}
                        {{ $t("MESSAGES.EXTERNAL_TEXT_INFORMATION_SMS") }}
                      </b-form-text>
                      <b-button
                        v-if="
                          settings.email_body != '' &&
                          settings.unlock_email_body
                        "
                        @click="unlockEmailBody"
                        size="sm"
                        class="no-border mt-2 mb-2"
                        ><i class="fal fa-unlock"></i>
                        {{ $t("BTN_UNLOCK_EMAIL_BODY") }}</b-button
                      >
                    </div>
                    <div class="float-right">
                      <div class="text-right">
                        <small class="pull-right"
                          >{{ external_text.length }}/1500</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <PickDateTime
                @changedFrom="changeFromDate"
                @changedTo="changeToDate"
              ></PickDateTime>

              <small>{{ $t("MEETINGS.BEFORE") }}</small>

              <hr class="p-0 m-0 mt-2 mb-2" />

              <b-button @click="closeBtn">{{ $t("CLOSE") }}</b-button>

              <b-button
                :disabled="disabledStep2"
                @click="gotoStep2"
                variant="primary"
                class="btn-fill"
                >{{ $t("NEXT") }}</b-button
              >
            </div>
            <div v-show="step == 2">
              {{ $t("MESSAGES.NOT_REGISTERED_INFORMATION") }}
              <div v-if="showExternal">
                <div class="mt-2" :key="step1index">
                  <div
                    v-for="(item, index) in external_participants"
                    :key="index"
                    class="NotRegistered"
                  >
                    <NotRegistered
                      @setValidated="setValidated"
                      :methods="methods"
                      :loa_level="loa_level"
                      :item="item"
                      :index="index"
                      :show-sefos="showSefos(item)"
                    ></NotRegistered>
                  </div>
                </div>

                <hr class="p-0 m-0 mt-2 mb-2" />

                <b-button @click="gotoStep1">{{ $t("BACK") }}</b-button>
                <b-button
                  :disabled="disabledSend"
                  @click="sendMeeting()"
                  variant="primary"
                  class="btn-fill"
                  >{{ $t("SEND") }}</b-button
                >
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </b-sidebar>
  </span>
</template>
<script>
import PickDateTime from "@/components/Compose/PickDateTime";
import * as blobUtil from "blob-util";
import SearchRecipients from "@/components/Compose/SearchRecipients";
import NotRegistered from "@/components/Compose/NotRegistered";
export default {
  props: ["show"],
  components: {
    SearchRecipients,
    NotRegistered,
    PickDateTime,
  },
  data() {
    return {
      settings: null,
      forceRedrawRecipientsIndex: 0,
      addedIndex: 0,
      message_uuid: "",
      step1index: 0,
      validated: [],
      step: 1,
      content: "",
      subject: "",
      loa_level: 1,
      current_time: "",
      meeting_from: "",
      meeting_to: "",
      addresses: [],
      files: [],
      methods: [],
      loading: false,
      attachments: [],
      showExternal: false,
      participants: [],
      external_text: "",
      external_participants: [],
      process: 1,
    };
  },
  methods: {
    unlockSubject() {
      if (this.settings.unlock_subject == 1) {
        this.subject = this.settings.subject;
        this.settings.subject = "";
        this.settings.unlock_subject = 0;
      }
    },
    unlockEmailBody() {
      if (this.settings.unlock_email_body == 1) {
        this.settings.email_body = "";
        this.settings.unlock_email_body = 0;
      }
    },
    showSefos(item) {
      return this.registered.includes(item.email);
    },
    changeFromDate(val) {
      this.meeting_from = val;
    },
    changeToDate(val) {
      this.meeting_to = val;
    },
    searchedUser(email) {
      if (!this.addresses.includes(email)) {
        this.addresses.push(email);
      }
    },
    async closeBtn() {
      this.$emit("changeShow", false);
      this.$emit("sentMeeting");
    },
    async shown() {
      this.getSettings();
    },
    getSettings() {
      let self = this;
      self.loading = true;
      this.$http
        .post(this.user.hostname + "/settings/get", {
          setting: "JitsiSecure",
          organisation_uuid: this.user.information.organisation.organisation_uuid,
          functionbox_uuid: "",
        }
        )
        .then(function (result) {
          self.settings = result.data;
          self.loading = false;
          self.init();
        })
        .catch(function () {
          self.loading = false;
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    async init() {
      if (this.settings.subject != "") {
        this.subject = this.settings.subject;
      }
      if (this.settings.email_body != "") {
        this.external_text = this.settings.email_body;
      } else {
        if (this.user.information.signature != "") {
          this.external_text =
            "\n\n----------------------------\n" +
            this.user.information.signature;
        }
        /*setTimeout(() => {
          let input = document.getElementById("externalText");
          if(input != null)
          {
            input.setSelectionRange(0, 0);
          }
        }, 500);*/
      }
      await this.getMethods();
    },
    async gotoStep1() {
      this.step = 1;
      this.loading = false;
    },
    async gotoStep2() {
      this.loading = true;
      this.validated = [];
      this.external_participants = [];
      let result = await this.$http.post(
        this.user.hostname + "/meeting/check-registered",
        {
          emails: this.addresses,
        }
      );
      this.registered = result.data.registered;
      for (let ix = 0; ix < this.addresses.length; ix++) {
        this.external_participants.push({
          email: this.addresses[ix],
          authentication_method: "link",
          authentication_identifier: "",
          language: this.$i18n.locale,
        });
        this.validated.push({
          email: this.addresses[ix],
          valid: 1,
        });
      }
      this.showExternal = true;
      this.step = 2;
      this.loading = false;
    },
    authenticationImage(authentication_method) {
      return "/img/auth/" + authentication_method + ".png";
    },
    async getMethods() {
      let self = this;
      await this.$http
        .get(this.user.hostname + "/authenticate/external/methods")
        .then(function (result) {
          self.methods = result.data;
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
          self.$noty.error(self.$t(error.response));
        });
    },
    async verifyExternal() {
      if (this.external_participants.length == 0) {
        return true;
      }
      for (let ix = 0; ix < this.external_participants.length; ix++) {
        let external_participant = this.external_participants[ix];
        if (
          external_participant.authentication_method == "sms" &&
          external_participant.authentication_identifier == ""
        ) {
          return false;
        }
        if (
          external_participant.authentication_method == "bankid-se" &&
          external_participant.authentication_identifier == ""
        ) {
          return false;
        }
        if (
          external_participant.authentication_method == "freja" &&
          external_participant.authentication_identifier == ""
        ) {
          return false;
        }
      }
      return true;
    },
    setValidated(payload) {
      if (payload.value) {
        this.validated[payload.index].valid = 1;
      } else {
        this.validated[payload.index].valid = 0;
      }
    },
    async sendMeeting() {
      try {
        this.loading = true;
        let self = this;
        this.$http
          .post(this.user.hostname + "/jitsi/confidentially/secure", {
            send_creator: 1,
            subject: this.subject,
            body: this.content,
            attachments: this.attachments,
            participants: this.participants,
            external_text: this.external_text,
            external_participants: this.filteredParticipants,
            settings: {
              require_response: 0,
              loa_level: 1,
              open_to_date: this.meeting_to,
              open_from_date: this.meeting_from,
            },
          })
          .then(function (result) {
            self.attachments = [];
            self.message_uuid = result.data.message_uuid;
            self.loading = false;
            self.$noty.info(self.$t("SENT_MEETING"));
            self.closeBtn();
            /*
            if (result.data.all_sent != undefined) {
              if (result.data.all_sent) {
                self.$noty.info(self.$t("SENT_MEETING"));
              } else {
                self.$noty.warning(self.$t("SENT_MEETING_NOT_SENT"));
              }
            } else {
              self.$noty.info(self.$t("SENT_MEETING"));
            }*/
          })
          .catch(function () {
            self.loading = false;
            self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
          });
      } catch (error) {
        throw error;
      }
    },
    downloadICS: function (message_uuid) {
      let name = "meeting.ics";
      let self = this;
      this.$http
        .get(this.user.hostname + "/jitsi/ics/" + message_uuid)
        .then((response) => {
          let blob = blobUtil.arrayBufferToBlob(response.data, "text/calendar");
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, name);
          } else {
            let $link = document.createElement("a");
            let url = URL.createObjectURL(blob);
            $link.setAttribute("target", "_blank");
            $link.setAttribute("href", url);
            $link.setAttribute("download", name);
            $link.style.visibility = "hidden";
            document.body.appendChild($link);
            $link.click();
            document.body.removeChild($link);
            self.$emit("sentMeeting");
          }
        })
        .catch(function () {
          self.$emit("sentMeeting");
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
  },
  computed: {
    disabledStep2: function () {
      if (this.external_text.length >= 1500) {
        return true;
      }
      if (this.subject.length >= 256) {
        return true;
      }
      if (this.meeting_from >= this.meeting_to) {
        return true;
      } else {
        if (this.user.services.meetings.jitsi_confidential_subject_enabled) {
          if (this.addresses.length != 0) {
            return false;
          } else {
            return true;
          }
        } else {
          if (this.addresses.length != 0 && this.subject != "") {
            return false;
          } else {
            return true;
          }
        }
      }
    },
    disabledSend: function () {
      if (
        this.filteredParticipants.length == 0 &&
        this.registered.length == 0
      ) {
        return true;
      } else {
        if (this.external_participants.length != 0) {
          if (
            this.external_participants.length ==
            this.validatedParticipants.length
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    canVerify() {
      if (this.addresses.length == 0) {
        return false;
      }
      if (!this.user.services.meetings.jitsi_confidential_subject_enabled) {
        if (this.subject == "") {
          return false;
        }
      }
      return true;
    },
    filteredParticipants() {
      return this.external_participants.filter(function (item) {
        return item.authentication_method !== "donotsend";
      });
    },
    filteredRemovedParticipants() {
      return this.external_participants.filter(function (item) {
        return item.authentication_method == "donotsend";
      });
    },
    validatedParticipants() {
      return this.validated.filter(function (item) {
        return item.valid == 1;
      });
    },
  },
};
</script>
